"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITOP_TICKET_URGENCY = exports.ITOP_TICKET_URGENCY_MAP = exports.ITOP_TICKET_IMPACT = exports.ITOP_TICKET_IMPACT_MAP = exports.ITOP_TICKET_DESCRIPTION_FORMAT = exports.ITOP_TICKET_OPERATIONAL_STATUS = void 0;
exports.ITOP_TICKET_OPERATIONAL_STATUS = {
    CLOSED: 'closed',
    ONGOING: 'ongoing',
    RESOLVED: 'resolved',
};
exports.ITOP_TICKET_DESCRIPTION_FORMAT = {
    TEXT: 'text',
    HTML: 'html',
};
//
exports.ITOP_TICKET_IMPACT_MAP = {
    1: 'Un departamento',
    2: 'Un servicio',
    3: 'Una persona',
};
exports.ITOP_TICKET_IMPACT = {
    UN_DEPARTAMENTO: 1,
    UN_SERVICIO: 2,
    UNA_PERSONA: 3,
};
exports.ITOP_TICKET_URGENCY_MAP = {
    1: 'Crítica',
    2: 'Alta',
    3: 'Media',
    4: 'Baja',
};
exports.ITOP_TICKET_URGENCY = {
    CRITICA: 1,
    ALTA: 2,
    MEDIA: 3,
    BAJA: 4,
};
